import { useIntl } from 'react-intl'
import ShoppingBagOutlinedIcon from '@mui/icons-material/ShoppingBagOutlined'
import AccessTimeIcon from '@mui/icons-material/AccessTime'
import EditOutlinedIcon from '@mui/icons-material/EditOutlined'
import { useNavigate } from 'react-router-dom'
import { useAppSelector } from '@/store'
import {
	selectSelectedOrderType,
	selectIsDeferred,
	selectExpectedTimeUtc,
} from '@/store/ticketSlice'
import { useLocationRef } from '@/contexts/RefContext'
import { PATHS } from '@/router/paths'
import { convertMinutesToHoursAndMinutes } from '@/lib/timeUtils'
import { useFormatMessage } from '@/translations/useFormatMessage'
import { formatScheduledTime } from '@/lib/formatScheduledTime'
import {
	ActionsFooterRoot,
	OrderDetailsRow,
	OrderDetailsPairs,
	OrderDetailsPair,
	TimingPair,
	OrderTypeLabel,
	TimingText,
	TimingBold,
	EditIconButton,
} from './CartActionsFooter.styled'
import { CheckoutButton } from './CheckoutButton'

export function CartActionsFooter() {
	const intl = useIntl()
	const { t } = useFormatMessage()
	const navigate = useNavigate()
	const locationRef = useLocationRef()

	const orderType = useAppSelector(selectSelectedOrderType)
	const isDeferred = useAppSelector(selectIsDeferred)
	const expectedTimeUtc = useAppSelector(selectExpectedTimeUtc)

	if (!orderType) return null

	const timingLabel = (() => {
		if (isDeferred && expectedTimeUtc) {
			return {
				bold: '',
				regular: formatScheduledTime(
					expectedTimeUtc,
					intl.locale,
					t('orderSettings:todayLabel'),
				),
			}
		}
		const leadMins = orderType.pickupLeadTimeInMinutes
		const duration =
			leadMins != null
				? `${intl.formatMessage({ id: 'orderSettings:asapSubtitleAbout' })} ${convertMinutesToHoursAndMinutes(leadMins)}`
				: intl.formatMessage({ id: 'orderSettings:asapSubtitleFallback' })
		return { bold: t('orderSettings:asapLabel'), regular: ` ${duration}` }
	})()

	function handleEditOrderSettings() {
		void navigate(`${PATHS.orderSettings(locationRef)}?edit=1`)
	}

	return (
		<ActionsFooterRoot>
			<OrderDetailsRow>
				<OrderDetailsPairs>
					<OrderDetailsPair>
						<ShoppingBagOutlinedIcon
							sx={{ fontSize: 20, flexShrink: 0 }}
							aria-hidden="true"
						/>
						<OrderTypeLabel>{orderType.name}</OrderTypeLabel>
					</OrderDetailsPair>

					<TimingPair>
						<AccessTimeIcon sx={{ fontSize: 20, flexShrink: 0 }} aria-hidden="true" />
						<TimingText>
							{timingLabel.bold ? <TimingBold>{timingLabel.bold}</TimingBold> : null}
							{timingLabel.regular}
						</TimingText>
					</TimingPair>
				</OrderDetailsPairs>

				<EditIconButton
					onClick={handleEditOrderSettings}
					aria-label={t('component:cartActionsFooter:editOrderSettings:label')}
				>
					<EditOutlinedIcon sx={{ fontSize: 20 }} aria-hidden="true" />
				</EditIconButton>
			</OrderDetailsRow>

			<CheckoutButton />
		</ActionsFooterRoot>
	)
}
